import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'
import index from './steps/index'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
  modules: {
    steps: index,
  },
}
